import { PNotifyService } from '../../../services/pnotify.service';
import { ExcelService } from '../../../services/excel.service';
import { AuthService } from '../../../services/auth.service';
import { IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { Component, OnInit, NgZone } from '@angular/core';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgxRolesService } from 'ngx-permissions';
import { Router } from '@angular/router';
import { School } from '../../../models/school';
import { Alert } from '../../../models/alert';
declare var $;
declare const google: any;
const jsPDF = require('jspdf');
require('jspdf-autotable');

@Component({
  selector: 'app-journey-activity-report',
  templateUrl: './journey-activity-report.component.html',
  styleUrls: ['./journey-activity-report.component.css']
})
export class JourneyActivityReportComponent implements OnInit {

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    journeyId: '',
    date: new Date(),
    inputFrom: '',
    inputTo: '',
    timeFrom: '',
    timeTo: '',
    raduis: '30'
  };
  isFirstFilter = true;

  time = {
    inputFrom: null,
    inputTo: null
  };

  public timeIntervalFrom;
  public timeIntervalTo;

  clients: any[];
  schools: any[];
  buses: any[];
  journeys: any[];

  public clientsData: any[];
  public schoolsData: any[];
  public busesData: any[];
  public journeysData: any[];
  public raduisData: any[];

  school: School;
  // Map Option
  option: any;
  map: any;
  markers: any[];
  mapView: any;
  mapData: {};
  markerBounds: any;
  loadData = false;
  titleInformation: any;
  selectedBusName: any;
  selectedJourneyName: any;
  selectedJourneyStart: any;
  selectedJourneyEnd: any;
  hStart: any;
  hEnd: any;

  directionsService: any;
  directionsRenderer: any;

  // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  multiSelectSettingsSchool: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: false,
    showUncheckAll: false,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block',
    selectionLimit: 1,
    autoUnselect: true
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // ----- End MultiSelect -----------

  categories: { days: string[], buses: string[] };
  periodPerformance: any[];
  periodMaxSpeed: any[];
  periodMileage: any[];

  // KPIExecution : any;
  // orderExecution : any;
  // totatExecutionTime : any;
  // totatWaitingTime : any;
  stopsName : any[];
  stopsPassengers : any[];
  stopsRealArrivalTime : any[];
  stopsEstimatedArrivalTime : any[];
  stopsWaitingTime : any[];
  stopsWaitingTimeSeconds : number[] = [];
  totalWaitingTime = '';
  journeyStartLat : any;
  journeyStartLng : any;
  journeyStopLat : any;
  journeyStopLng : any;


  Highcharts: typeof Highcharts = Highcharts;
  chart1Options: {};
  chart2Options: {};
  chart3Options: {};

  hourFormat = function (num) {
    const m = moment.utc(num * 1000);
    return m.format('HH:mm');
  };
  HMSFormat = function (num) {
    const m = moment.utc(num * 1000);
    return m.format('HH:mm:ss');
  };
  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  dateTimeFilter = (d: Date): boolean => {
    return true;
  }

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.categories = {
      days: [],
      buses: []
    };
    this.periodPerformance = [[], []];
    this.periodMaxSpeed = [[], []];
    this.periodMileage = [[], []];
    this.initClientSelect();
  }

  ngOnInit() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        this.filter.clientId = clients && clients.length ? clients[0].id : '';
        this.clientsData = this.clients.map((client, index) => {
          return { id: client.id, text: client.name, selected: client.id === this.filter.clientId };
        });
        this.initSchoolSelect();
      });
    }
  }
  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const school = this.authService.getUser().School;
      this.school = school;
      this.schools = [{ id: school.id, name: school.name }];
      this.filter.schoolId = school.id;
      this.initBusSelect();
    } else {
      const params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId
        }
      });
      this.http.get(
        '/api/school/lookup',
        { params }
      ).subscribe((schools: any[]) => {
        this.schools = schools;
        this.filter.schoolId = schools && schools.length ? schools[0].id : '';
        this.schoolsData = this.schools.map((school, index) => {
          if ((this.filter.schoolId === school.id)) {
            this.school = school;
          }
          return { id: school.id, text: school.name, selected: school.id === this.filter.schoolId };
        });
        this.initBusSelect();
        this.initZoneAnalysis();
      });
    }
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initZoneAnalysis(){
    this.raduisData = [
                      { id: '30', text: '30 m'},
                      { id: '40', text: '40 m'},
                      { id: '50', text: '50 m'},
                      { id: '60', text: '60 m'},
                      { id: '70', text: '70 m'},
                      { id: '80', text: '80 m'},
                      { id: '90', text: '90 m'},
                      { id: '100', text: '100 m'},
                      { id: '110', text: '110 m'}
                      ];
  }

  zoneAnalysisChanged(e: any) {
    this.filter.raduis = e.value;
    console.log("Raduis: " + this.filter.raduis );
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
    this.initMap();
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
    // console.log("---------------> Event:",e);
    this.selectedBusName = e.data[0].text;
    this.initJourneySelect();
  }

  initJourneySelect() {
    this.filter.journeyId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busId: this.filter.busId
      }
    });
    this.http.get(
      '/api/journey/lookup',
      { params }
    ).subscribe((journeys: any[]) => {
      this.journeys = journeys;
      const array1 = [{ id: '', text: 'Choisir un trajet', debut: '', fin: ''}];
      const array2 = this.journeys.map(function (journey, index) {
        journey.start = new Date(Number(journey.start) * 1000);
        journey.end = new Date(Number(journey.end) * 1000);
        return { id: journey.id, text: journey.name, debut: journey.start , fin: journey.end};
      });
      this.journeysData = array1.concat(array2);
    });

     //this.initMap();
  }

  journeyChanged(e: any) {
    this.filter.journeyId = e.value;
    this.selectedJourneyName = e.data[0].text;

    this.filter.inputFrom = e.data[0].debut;
    this.filter.inputTo = e.data[0].fin;
    this.filter.timeFrom = moment(e.data[0].debut).format('HH:mm');
    this.filter.timeTo = moment(e.data[0].fin).format('HH:mm');
  }

  changeTimeJourney(){
    const inputFrom = this.getElapsedSecondsInDay(this.filter.inputFrom);
    const inputTo   = this.getElapsedSecondsInDay(this.filter.inputTo);
    if (inputFrom > inputTo) {
      this.filter.inputTo = '';
    } else {
      this.filter.timeFrom = moment(this.filter.inputFrom).format('HH:mm');
      this.filter.timeTo = moment(this.filter.inputTo).format('HH:mm');
    }
  }

  getDataFromBus(id) {
    return function (element) {
      return element.busId === id;
    };
  }

  initMap() {
    this.directionsService = new google.maps.DirectionsService;
    this.directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    const center = { lat: Number(this.school.lat), lng: Number(this.school.lng) };
    this.option = {
      center: center,
      zoom: 8,
      gestureHandling: 'cooperative'
    };
    let map;
    map = new google.maps.Map(document.getElementById('journey-map'), this.option);
    this.map = map;
    this.directionsRenderer.setMap(map);
    this.markerBounds = new google.maps.LatLngBounds();
    //this.markers = [];
    const marker = new google.maps.Marker({
      position: { lat: Number(this.school.lat), lng: Number(this.school.lng) },
      map: this.map,
      zIndex: 1,
      icon: 'assets/images/markers/school.png',
    });
  }

  createLineBus(bus, locations, map) {
    const infowindow = new google.maps.InfoWindow();
    const path = [];
    for (let i = 0; i < locations.length; i++) {
      const isFirst = i === 0 ? true : false;
      const isLast = i === locations.length - 1 ? true : false;

      const pos = new google.maps.LatLng(parseFloat(locations[i].lat), parseFloat(locations[i].lng));
      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(pos);

      let content = '';
      let label = null;
      let icon = null;
      if (isFirst && i === 0) {
        content = '<h1 style="text-align: center;">Départ</h1>';
        label = 'D';
      } else if (isLast && i === locations.length - 1) {
        content = '<h1 style="text-align: center;">Arrivée</h1>';
        label = 'A';
      } else if (locations[i].speed === 0) {
        icon = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            fillColor: '#F00',
            fillOpacity: 0.9
        };
      } else {
        icon = {
            // url: this.createMarkerColored(color, locations[i].BusEvent),
            // origin: new google.maps.Point(0, 0),
            // anchor: new google.maps.Point(15, 15),
            // flat: true
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 4.5,
            strokeColor: '#ffffff',
            strokeWeight: 1.5,
            //fillColor: '#3498db',
            fillColor: bus.colorLineBus,
            fillOpacity: 0.9,
            rotation: locations[i].angle
        };
      }

      // window.alert(locations[i].angle);
      const marker = new google.maps.Marker({
        position: pos,
        map: map,
        label: label,
        icon: icon
      });
      this.markerBounds.extend(pos);

      const this_ = this;
      marker.addListener('click', function () {
        const position = locations[i].lat + ',' + locations[i].lng;

        content = `<b>Bus :</b> ${bus.name}<br/>
          <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
          <b>Position :</b> ${position} <br/>
          <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

        content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
      });

      marker.addListener('mouseover', function() {
        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

         content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

         infowindow.setContent(content);
         infowindow.open(map, marker);
      });
      marker.addListener('mouseout', function() {
         infowindow.close();
      });

      if (isLast) {
        this.loadData = false;
      }
    }
    const poly = new google.maps.Polyline({
      path: path,
      geodesic: true,
      //strokeColor: '#3498db',
      strokeColor: bus.colorLineBus,
      strokeOpacity: 0.8,
      strokeWeight: 3,
      // icons: [{
      //   icon: { path: google.maps.SymbolPath.FORWARD_OPEN_ARROW },
      //   offset: '10%',
      //   repeat: '500px'
      // }]
    });
    poly.setMap(map);

  }



createPassengers(passengers, map) {

    const infowindow = new google.maps.InfoWindow();
    this.markers = [];
    let icon = '';
    const offsets = this.buildSpiderfyOffsets(passengers);
    for (let i = 0; i < passengers.length; i++) {
      if (passengers[i].isPositionValide) {
        const realPos = new google.maps.LatLng(passengers[i].lat, passengers[i].lng);
        const off = offsets[i];
        const pos = off ? new google.maps.LatLng(off.lat, off.lng) : realPos;
        if (passengers[i].isAssistant) {
          icon = 'assets/images/markers/Assistant_Home.png';
        } else {
          icon = 'assets/images/markers/passenger.png';
        }
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          icon: icon,
        });
        this.markers.push(marker);
        this.markerBounds.extend(pos);

        const _this = this;
        google.maps.event.addListener(marker, 'click', ((marker, i) => {
          return function () {
            const content = `<b>Nom : </b>${passengers[i].lastname}<br />
            <b>Prénoms : </b>${passengers[i].firstnames}<br />`;
            
            infowindow.setContent(content);
            infowindow.open(map, marker);

          };
        })(marker, i));

        const yourcircle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: .8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.2,
          map: map,
          center:  realPos,
          radius: parseInt(this.filter.raduis, 10),
        });

      }
    }
    // window.alert(markers.length);
  }

  /**
   * Compute small circular offsets for items sharing the exact same position,
   * so overlapping markers stay individually visible/clickable.
   * Returns an array aligned with `items` (null = no offset needed).
   */
  buildSpiderfyOffsets(items: any[]): ({ lat: number, lng: number } | null)[] {
    const offsets: ({ lat: number, lng: number } | null)[] = items.map(() => null);
    const groups: { [key: string]: number[] } = {};
    items.forEach((it, idx) => {
      const lat = Number(it.lat);
      const lng = Number(it.lng);
      const key = (isNaN(lat) ? 0 : lat.toFixed(6)) + ',' + (isNaN(lng) ? 0 : lng.toFixed(6));
      (groups[key] = groups[key] || []).push(idx);
    });
    for (const key in groups) {
      const idxs = groups[key];
      if (idxs.length <= 1) continue;
      const baseLat = Number(items[idxs[0]].lat);
      const baseLng = Number(items[idxs[0]].lng);
      const angleStep = (2 * Math.PI) / idxs.length;
      const radius = 0.0003;
      idxs.forEach((idx, k) => {
        const angle = angleStep * k;
        offsets[idx] = {
          lat: baseLat + radius * Math.cos(angle),
          lng: baseLng + radius * Math.sin(angle)
        };
      });
    }
    return offsets;
  }

  displayPosition(i:any) {
    if (i === 0){
      const center = new google.maps.LatLng(this.journeyStartLat, this.journeyStartLng);
      this.map.setCenter(center);
      this.map.setZoom(18);
    }else if(i === this.stopsName.length -1){
      const center = new google.maps.LatLng(this.journeyStopLat, this.journeyStopLng);
      this.map.setCenter(center);
      this.map.setZoom(18);
    } else {
      const infowindow = new google.maps.InfoWindow();
      const center = new google.maps.LatLng(this.stopsPassengers[i-1].lat, this.stopsPassengers[i-1].lng);
      this.map.setCenter(center);
      this.map.setZoom(18);
      const content = `<b>Ordre : </b>${i}<br />
            <b>Nom : </b>${this.stopsPassengers[i-1].lastname}<br />
            <b>Prénoms : </b>${this.stopsPassengers[i-1].firstnames}<br />
            <b>Horaire reél : </b>${this.stopsRealArrivalTime[i-1]}<br />
            <b>Horaire programmé : </b>${this.hourFormat(this.stopsEstimatedArrivalTime[i])}<br />
            `;
      infowindow.setContent(content);
      infowindow.open(this.map, this.markers[i-1]);
    }
    //document.querySelector('#journey-map').scrollIntoView({ behavior: 'smooth' });
  }

  getWaitingDuration (busPositions, passengers){

    let tempDistance = 0;
    let tempPositionsInside = [];
    let tempPositionsInsideWithoutStop = [];
    this.stopsWaitingTime = [];
    this.stopsWaitingTimeSeconds = [];
    this.stopsRealArrivalTime = [];

    passengers.forEach((passenger, index) => {
      tempPositionsInside = [];
      tempPositionsInsideWithoutStop = [];

      // 1- On cherche positions inside raduis with home position is the center
      for (let i = 0; i < busPositions.length; i++) {

        tempDistance = this.getDistanceInMeter(passenger.lat, passenger.lng,busPositions[i].lat,busPositions[i].lng);
        if (tempDistance < parseInt(this.filter.raduis, 10) && busPositions[i].speed < 8){
          tempPositionsInside.push(busPositions[i]);
        } else if (tempDistance < parseInt(this.filter.raduis, 10) && busPositions[i].speed > 7){
          tempPositionsInsideWithoutStop.push(busPositions[i]);
        }
      }

      // 2- On calcule la durée max
      if (tempPositionsInside.length > 0) {

        this.stopsRealArrivalTime.push(moment.utc(tempPositionsInside[0].time).format('HH:mm')+'');

        let dt1_string = moment.utc(tempPositionsInside[0].time).format('HH:mm:ss')+'';
        let dt2_string = moment.utc(tempPositionsInside[tempPositionsInside.length-1].time).format('HH:mm:ss')+'';

        let diff_time = this.diffenceTime (dt2_string,dt1_string);

        if (diff_time > 60) {
          this.stopsWaitingTime.push(Math.round(diff_time / 60) + ' min');
          this.stopsWaitingTimeSeconds.push(diff_time);
        } else if (diff_time == 0) {
          this.stopsWaitingTime.push('moins de 10 sec');
          this.stopsWaitingTimeSeconds.push(0);
        } else {
          this.stopsWaitingTime.push(diff_time + ' sec');
          this.stopsWaitingTimeSeconds.push(diff_time);
        }

         //console.log(passenger.lastname +" between "+ dt1_string+ " and " + dt2_string);
         //console.log(tempPositionsInside);
      } else if (tempPositionsInsideWithoutStop.length > 0) {
        this.stopsRealArrivalTime.push(moment.utc(tempPositionsInsideWithoutStop[tempPositionsInsideWithoutStop.length-1].time).format('HH:mm')+'');
        this.stopsWaitingTime.push('Passage de bus sans arrêt');
        this.stopsWaitingTimeSeconds.push(0);
      } else {
        this.stopsRealArrivalTime.push('--:--');
        this.stopsWaitingTime.push('-');
        this.stopsWaitingTimeSeconds.push(0);
      }
    });

    const totalSeconds = this.stopsWaitingTimeSeconds.reduce((sum, v) => sum + (v || 0), 0);
    this.totalWaitingTime = this.formatTotalDuration(totalSeconds);
    console.log(this.stopsWaitingTime);
  }

  formatTotalDuration(totalSeconds: number): string {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    if (mins > 0) {
      return mins + ' min ' + secs + ' sec';
    }
    return secs + ' sec';
  }

  getDistanceInMeter (latCenter, longCenter, lat, lng ){
    return Math.acos( Math.sin(latCenter*Math.PI/180)*Math.sin(lat*Math.PI/180) + Math.cos(latCenter*Math.PI/180)*Math.cos(lat*Math.PI/180)*Math.cos(lng*Math.PI/180-longCenter*Math.PI/180) ) * 6371000;
  }

  diffenceTime (dt2_string,dt1_string){
    let dt1 = new Date();
    let dt2 = new Date();
    let value_dt1 = (dt1_string+":00").split(':');
    let value_dt2 = (dt2_string+":00").split(':');

    dt1.setHours(parseInt(value_dt1[0], 10), parseInt(value_dt1[1], 10), parseInt(value_dt1[2], 10), 0);
    dt2.setHours(parseInt(value_dt2[0], 10), parseInt(value_dt2[1], 10), parseInt(value_dt2[2], 10), 0);

    let diff =(dt2.getTime() - dt1.getTime()) / 1000;

    return Math.abs(Math.round(diff));// difference in second
  }


  onFilter() {

    this.loadData = true;
    this.initMap();
    this.titleInformation = this.selectedBusName + ' - ' + this.selectedJourneyName + ' (' + moment(this.filter.date).format('DD-MM-YYYY') + ')';

    this.stopsName = [];
    this.stopsEstimatedArrivalTime = [];
    this.stopsPassengers =[];
    this.journeyStartLat = '';
    this.journeyStartLng = '';
    this.journeyStopLat = '';
    this.journeyStopLng = '';
    this.stopsWaitingTime = [];
    this.stopsRealArrivalTime = [];

    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId+ '',
        schoolId: this.filter.schoolId+ '',
        busId: this.filter.busId+ '',
        journeyId: this.filter.journeyId+ '',
        date: moment(this.filter.date).format('YYYY-MM-DD'),
        timeFrom: this.filter.timeFrom,
        timeTo: this.filter.timeTo
      }
    });

    // Activity report
    this.http.get(
      '/api/activityReport/journeyReport',
      { params }
    ).subscribe((data: any) => {

      // Create passager on the Map
      this.createPassengers(data.stopsPassengers, this.map);


      for (let i = 0; i < data.stopsName.length; i++) {
        console.log ('==>' + data.stopsEstimatedArrivalTime[i]);
      }
      this.stopsName = data.stopsName;
      this.stopsEstimatedArrivalTime = data.stopsEstimatedArrivalTime;
      this.stopsPassengers = data.stopsPassengers;
      this.journeyStartLat = data.journeyStartLat;
      this.journeyStartLng = data.journeyStartLng;
      this.journeyStopLat = data.journeyStopLat;
      this.journeyStopLng = data.journeyStopLng;
    });

    // Joureny Map
    let url = '/api/activityReport/mapJourneyReport';
    this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            // if (!data.positions.length) {
            //   this.loadData = false;
            // }
            this.loadData = false;
            const positions = data.positions.filter(this.getDataFromBus(data.buse[0].id));
            if (positions.length > 0) {
              this.createLineBus(data.buse[0], positions, this.map);
              this.getWaitingDuration(positions,this.stopsPassengers);
            }
            this.map.fitBounds(this.markerBounds);
          },
          error => {
            this.loadData = false;
          }
        );

    this.isFirstFilter = false;
  }

  downloadPdf() {
    if (!this.stopsName || this.stopsName.length === 0) return;

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.setFont('', 'bold');
    const title = 'Rapport trajet';
    const textWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    const titleOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(titleOffset, 15, title);

    doc.setFontSize(10);
    doc.setFont('', 'normal');
    doc.text(15, 22, this.titleInformation || '');

    const body = [];
    for (let i = 1; i < this.stopsName.length - 1; i++) {
      const p = this.stopsPassengers && this.stopsPassengers[i - 1] ? this.stopsPassengers[i - 1] : null;
      body.push([
        i,
        this.stopsName[i],
        p ? p.firstnames : '-',
        (this.stopsRealArrivalTime[i - 1] || '--:--') + ' (vs ' + this.hourFormat(this.stopsEstimatedArrivalTime[i]) + ')',
        this.stopsWaitingTime[i - 1] || '-'
      ]);
    }

    doc.autoTable({
      startY: 28,
      theme: 'striped',
      headStyles: { fillColor: '#15a4f7', textColor: '#fff' },
      head: [['Ordre', 'Point d\'arrêt', 'Prénoms', 'Horaire réel (vs programmé)', 'Durée d\'attente estimé']],
      body: body,
      foot: [['', '', '', 'Total', this.totalWaitingTime]],
      footStyles: { fillColor: '#f5f5f5', textColor: '#333', fontStyle: 'bold' }
    });

    doc.save('rapport-trajet.pdf');
  }


}





// WEBPACK FOOTER //
// ./src/app/components/activity-report/journey-activity-report/journey-activity-report.component.ts